module.exports = __webpack_public_path__ + "img/go_top.21bb5723.png";